import styled, { css } from 'styled-components';
import { MediaQuery } from '../../../theme/style-helpers';
import { SummaryContainer, Table, TableCell } from '../css';

export const Container = styled(SummaryContainer)`
    ${MediaQuery.medium(css`
        grid-template-columns: 1fr 1fr 1fr;
        gap: 32px;
    `)};
`;

export const ItemTable = styled(Table)`
    grid-column: 1 / -1;

    ${MediaQuery.xLarge(css`
        grid-template-columns: repeat(5, 1fr);
        column-gap: 48px;
        row-gap: 32px;
    `)};
`;

export const ItemTableCell = styled(TableCell)`
    ${MediaQuery.xLarge`
        flex-direction: column;
        justify-content: flex-start;
        grid-column: ${({ column }) => column || 'auto'};
        grid-row: ${({ row }) => row || 'auto'};
    `};
`;
export const TableDivider = styled.div`
    height: 1px;
    width: 100%;
    background-color: #D9D9D6;

    ${MediaQuery.xLarge`
        grid-column: ${({ column }) => column || '1 / -1'};
    `};

    &:last-child {
        display: none;
    }
`;
